export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is Oclusion Clinical Playbook™ a course?',
    answer:
      'No. It’s a digital clinical reference system created by Dr. Karito, containing six Playbooks, protocols, decision maps, checklists, matrices, worksheets and practical tools.',
  },
  {
    question: 'Who is this for?',
    answer:
      'The Playbook is designed primarily for dentists who work with — or want to become more confident in — organizing complex restorative and rehabilitation cases.',
  },
  {
    question: 'Do I need to be a specialist?',
    answer:
      'Not necessarily. However, your education, training, scope of practice and professional judgment should always determine how you apply any educational material.',
  },
  {
    question: 'Does this replace clinical education?',
    answer:
      'No. The Playbook is an educational and planning resource. It does not replace formal clinical training, patient-specific assessment, professional judgment or appropriate specialist referral.',
  },
  {
    question: 'How will I receive the product?',
    answer:
      'Immediately after your purchase, you’ll receive digital access to the Playbooks and bonuses.',
  },
  {
    question: 'Can I download the materials?',
    answer:
      'Yes. The materials are provided digitally for you to keep and reference according to the terms of your purchase.',
  },
  {
    question: 'Is this a one-time payment?',
    answer: 'Yes. You pay $27 once. There is no monthly subscription.',
  },
  {
    question: 'Do I get lifetime access?',
    answer:
      'Yes. You’ll have lifetime access to the purchased materials while the product remains available under the terms of the offer.',
  },
  {
    question: 'What happens if I don’t like it?',
    answer:
      'You have 7 days to explore the Playbook. If you decide it isn’t right for you, you can request a refund within the guarantee period.',
  },
  {
    question: 'What currency will I be charged in?',
    answer:
      'The checkout detects your location and converts the price to your local currency automatically. You always pay the equivalent of one single $27 payment.',
  },
]
